import {
  BlockModel,
  BlockSchemaExtension,
  defineBlockSchema,
} from '@blocksuite/affine/store';

type AgentStagesProps = {
  /**
   * Serialized `AgentRunState` — see
   * `@affine/core/modules/orchestration/state/agent-run-state.ts`.
   * JSON string so BlockSuite's Y.Doc CRDT can diff it as a single
   * atom; the doc-writer bumps it once per orchestration event (rAF-
   * debounced) rather than churning per-sub-step.
   */
  stagesJson: string;
  /**
   * Auto-flipped to `true` on `complete`. When `true`, the block
   * renders as a single "Research log · 12s · 4 agents · 8 sources"
   * summary row; click expands.
   */
  collapsed: boolean;
};

export const AgentStagesBlockSchema = defineBlockSchema({
  flavour: 'affine:agent-stages',
  props: (): AgentStagesProps => ({
    stagesJson: '',
    collapsed: false,
  }),
  metadata: {
    version: 1,
    role: 'content',
    children: [],
  },
  toModel: () => new AgentStagesBlockModel(),
});

export const AgentStagesBlockSchemaExtension = BlockSchemaExtension(
  AgentStagesBlockSchema
);

export class AgentStagesBlockModel extends BlockModel<AgentStagesProps> {}
